import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { Alert, Button, Scrollbar, Typography } from 'shared/ui'
import { DefaultModalActions } from 'shared/ui/Modal/ui/DefaultModal/DefaultModalActions'
import { formatPhoneNumberNational } from 'shared/lib'
import { type ImportTwilioNumbersStore } from 'pages/settings/pages/numbers/ui/ImportTwilioNumbers/store/ImportTwilioNumbersStore'
import styles from './styles.module.scss'

type IImportTwilioNumbersUiProps = {
  store: ImportTwilioNumbersStore
}

export const ImportTwilioNumbersUi = observer(({ store }: IImportTwilioNumbersUiProps) => {
  const { numbers, onNext, onClose } = store

  const [loading, setLoading] = useState(false)
  const handleNext = async () => {
    setLoading(true)
    await onNext()
    setLoading(false)
  }
  return (
    <>
      <div className={styles.alert}>
        <Alert
          item={{
            type: 'infoLight',
            desc: 'All numbers from the list will be imported into Salesmsg. If you don’t want to import certain numbers, please release them in your Twilio account before continuing. If you’re out of free licenses, we’ll add what you need and show the full price before you confirm.',
          }}
        />
      </div>

      <div className={styles.list}>
        <Scrollbar autoHeight autoHeightMax={208}>
          {numbers.map((number) => (
            <div key={number.sid} className={styles.row}>
              <Typography variant={'text-input-field-r'} ariaLabel={'Number'}>
                {formatPhoneNumberNational(number.phone_number)}
              </Typography>
            </div>
          ))}
        </Scrollbar>
      </div>
      <DefaultModalActions>
        <Button
          typeBtn={'contained'}
          text={'Cancel'}
          size={'medium'}
          contained={'secondary'}
          onClick={onClose}
        />
        <Button
          typeBtn={'contained'}
          text={'Next'}
          size={'medium'}
          contained={'primary'}
          onClick={handleNext}
          loading={loading}
        />
      </DefaultModalActions>
    </>
  )
})
